import { IconFilledCompanyLogo } from '@/public/assets/svg/icon-company-filled-logo';
import { Box } from '@mantine/core';

export const CompanyLogo = () => {
  return (
    <Box>
      <IconFilledCompanyLogo />
    </Box>
  );
};
